export default {"src":"/_next/static/media/chat.3d2c63d2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};